module.exports = __webpack_public_path__ + "static/img/pro03.37765c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/img/pro03.jpg
// module id = f4xX
// module chunks = 1